<template>
  <v-card>
    <v-card-title class="primary white--text">
      <span>{{ title }}</span>
      <v-spacer></v-spacer>
      <BaseDialogActions hideRefresh/>
    </v-card-title>
    <v-card-text>
      <FormWrapper
      :buttonText="$t('saveChanges')"
      @submit="saveChanges"
      >
        <v-container fluid>
          <v-row dense>
            <v-col cols="12">
              <v-textarea
                v-model="kioskInstructions"
                :label="$t('kioskInstructions')"
                :counter="instructionMaxLength"
                :maxlength="instructionMaxLength"
                rows="1"
                auto-grow
                dense
                outlined
                :hint="$t('displayedToOperatorsAtKiosk')"
                color="primary"
              />
            </v-col>
          </v-row>
          <v-row dense class="mt-4">
            <v-col cols="12">
              <span class="subtitle-2 text-uppercase">{{ $t('completedTicketCopies') }}</span>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-btn-toggle v-model="selectedPrintCount" mandatory color="primary" dense>
                <v-btn :value="null">
                  {{ $t('notSet') }}
                  <Icon
                    class="ml-2"
                    icon="mdi-information-outline"
                    :small="true"
                    style="display: inline-flex"
                    :tooltipText="$t('kioskDefaultDescription')"
                    @icon-clicked="selectedPrintCount = null"
                  />
                </v-btn>
                <v-btn :value="1">1</v-btn>
                <v-btn :value="2">2</v-btn>
                <v-btn :value="3">3</v-btn>
                <v-btn :value="4">4</v-btn>
                <v-btn :value="5">5</v-btn>
              </v-btn-toggle>
            </v-col>
          </v-row>
        </v-container>
      </FormWrapper>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import { StringConstants } from '@/utils/constants'

export default {
  name: 'TractInstructionsForm',

  components: {
    Icon: () => import('@/components/helper/Icon.vue'),
    FormWrapper: () => import('@/components/core/FormWrapper.vue'),
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue')
  },

  props: {
    propTractInstructions: {
      type: Object,
      default: null
    },
    tractId: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    kioskInstructions: null,
    selectedPrintCount: null,
    instructionMaxLength: StringConstants.ExtraExtraLongStringLength
  }),

  computed: {
    isEditing () {
      return this.propTractInstructions !== null && this.propTractInstructions !== undefined
    },

    title () {
      return this.isEditing ? this.$t('editTractInstructions') : this.$t('newTractInstructions')
    }
  },

  created () {
    if (this.isEditing) {
      this.kioskInstructions = this.propTractInstructions.kioskInstructions ?? null
      this.selectedPrintCount = this.propTractInstructions.completedTicketPrintCount ?? null
    }
  },

  methods: {
    ...mapActions('tract-instructions', ['createTractInstructions', 'updateTractInstructions']),

    async saveChanges () {
      const instructions = {
        kioskInstructions: this.kioskInstructions || null,
        completedTicketPrintCount: this.selectedPrintCount ?? null
      }

      let result
      if (this.isEditing) {
        await this.updateTractInstructions({ tractId: this.tractId, instructions })
        result = instructions
      } else {
        result = await this.createTractInstructions({ tractId: this.tractId, instructions })
      }

      this.$emit('close', result)
    }
  }
}
</script>

<style scoped>
  .v-btn-toggle .v-btn {
    color: rgba(0, 0, 0, 0.87) !important;
  }
  .v-btn-toggle .v-btn.v-btn--active {
    color: white !important;
    background-color: rgba(0, 0, 0, 0.87) !important;
  }
  .chip-f0 {
    background-color: #f0f0f0 !important;
    outline: lightgrey solid 1px;
  }
</style>
